export default __webpack_public_path__ + "static/work-drops-9911debf0d148604cadffe6598bed73f.jpg";